<template>
  <div class="col-12">
    <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">
      {{ msg.content }}
    </Message>

    <Toast />

    <CardProcesso :processo="processo" />

    <Panel header="Locais de Prova" class="col-12 md:col-12 justify-content-center p-0" :toggleable="true" :collapsed="false" v-if="temProcessos">
      <Toolbar class="mb-4">
        <template #start>
          <div class="my-2">
            <Button label="Novo" icon="pi pi-plus" class="p-button-success mr-2" @click="abrirNovoLocalProva"/>
          </div>
        </template>
      </Toolbar>

      <DataTable :value="listaLocalProva" class="p-datatable-sm p-datatable-gridlines gridlines p-datatable-striped" dataKey="id">
        <Column field="id" header="ID"></Column>
        <Column field="nome" header="Nome Escola"></Column>
        <Column header="Áreas">
          <template #body="slotProps">
            <Tag v-for="localArea in slotProps.data.areasLocalProva" :key="localArea.id" class="mr-3">
              {{localArea.area.nome}}
            </Tag>
          </template>
        </Column>
        <Column field="quantidadeLugaresDisponiveis" header="Quantidade de lugares disponíveis" />
        <Column header="Estrutura da Escola">
          <template #body="slotProps">
            <Button
              icon="pi pi-building"
              class="p-button-rounded p-button-success mr-2"
              @click="detalharEscola(slotProps.data)"/>
          </template>
        </Column>
        <Column>
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success mr-2"
              @click="editarLocalProva(slotProps.data)"/>
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-warning"
              @click="excluirLocalProva(slotProps.data)"/>
          </template>
        </Column>
      </DataTable>
    </Panel>

    <Panel header="Distribuição das inscrições" class="col-12 md:col-12 justify-content-center p-0" :toggleable="true">

      <Message v-for="msg of messagesDistribuicao" :severity="msg.severity" :key="msg.content">{{ msg.content }}</Message>

      <EstruturaSalasDistribuicao :listaLocalProva="listaLocalProva" v-if="showEstruturaDistribuicao"></EstruturaSalasDistribuicao>

      <!-- <TabView class="col-12 md:col-12" v-show="temPendenciaDistribuicao() || !isDistribuido" scrollable > -->
        <TabView class="col-12 md:col-12" v-else-if="temPendenciaDistribuicao" scrollable >
        <TabPanel header="Pendências">
          <DataTable :value="pendenciasDistribuicao" class="m-5 ml-0 mr-0 mb-0">
            <Column header="Tipo" :headerStyle="{ width: '5rem' }">
              <template #body="slotProps">
                <Tag class="mr-3" severity="warning">
                  {{slotProps.data.tipo}}
                </Tag>
              </template>
            </Column>
            <Column field="descricao" header="Descrição" :headerStyle="{ width: '19rem' }"></Column>
          </DataTable>
        </TabPanel>
      </TabView>

      <div>
        <span v-tooltip.bottom="{value:'Não é possível distribuir local de prova', disabled: podeDistribuirLocalProva()}" >
          <Button
            class="mr-6 mb-2"
            label="Efetuar distribuição"
            type="submit"
            style="width: 150px"
            @click="distribuirLocalProva()"
            :disabled="!podeDistribuirLocalProva()">
          </Button>
        </span>

        <Button
          class="mr-2 mb-2 p-button-outlined p-button-secondary"
          label="Exportar"
          icon="pi pi-download"
          style="width: 150px"
          @click="download('exportação de salas')">
        </Button>

        <Button
          label="Exportar para Assinar"
          icon="pi pi-download"
          style="width: 200px"
          @click="downloadParaAssinar('exportação de salas para assinar')"
          class="mr-2 mb-2 p-button-outlined p-button-secondary">
        </Button>

        <Button
          label="Exportar cartões Ufam"
          icon="pi pi-download"
          style="width: 200px"
          @click="downloadCartoesUfam('Exportação cartões UFAM')"
          class="mr-2 mb-2 p-button-outlined p-button-secondary">
        </Button>

      </div>
    </Panel>

    <Dialog :visible.sync="aguardeDialog" header="Aguarde ..." :modal="true" :closable="false">
      <div class="aguarde">
        <ProgressSpinner />
      </div>
    </Dialog>

    <EditarLocalProva :cadastroEscolaDialog.sync="showEditarDialog" :localProvaEdicao="localProvaSelecionado" :processo="processo" :onAtualizarLista="setLocalProva"
                      :editar="flagEditarLocal"/>

    <DetalheEscola :detalheEscolaDialog.sync="showDetalheDialog" :editarDialog.sync="showEditarDialog" :processo="processo" :localProva="localProvaSelecionado"/>

    <DialogoConfirmacao :habilitar.sync="showConfirmacaoDialog" :onConfirmar="confirmarExclusao"/>

  </div>
</template>

<script>
import http from "@/http";
import { tratamentoDeErros } from "@/tratamentoDeErros";
import LocalProvaService from "../../service/LocalProvaService";
import SalaService from "../../service/SalaService";
import ProgressSpinner from "primevue/progressspinner";
import InscricaoService from "../../service/InscricaoService";
import CardProcesso from "../../components/CardProcesso.vue";
import ProcessoService from "../../service/ProcessoService";
import EstruturaSalasDistribuicao from "../../components/localProva/EstruturaSalasDistribuicao.vue";
import EditarLocalProva from '../../components/localProva/EditarLocalProva.vue';
import DetalheEscola from '../../components/localProva/DetalheEscola.vue';
import DialogoConfirmacao from "../../components/alerta/DialogoConfirmacao.vue";

// import Tooltip from 'primevue/tooltip';

export default {
  mixins: [tratamentoDeErros],

  components: { ProgressSpinner, CardProcesso, EstruturaSalasDistribuicao, EditarLocalProva, DetalheEscola, DialogoConfirmacao},
  // directives: { 'tooltip': Tooltip },
  data() {
    return {
      showEditarDialog: false,
      showDetalheDialog: false,
      showConfirmacaoDialog: false,
      carregandoLocalProva: false,
      localProvaService: null,
      localProvaSelecionado: null,
      salaService: null,
      qtCandidatos: null,
      flagEditarLocal: false,
      selectedArea: null,
      token: this.$store.state.token,
      cadastroEscolaDialog: false,
      inscritosDialog: false,
      temProcessos: false,
      messages: [],
      messagesDistribuicao: [],
      messagesCadastroLocal: [],
      listaLocalProva: [],
      areasPendente: [],
      pendenciasDistribuicao: [],
      // isDistribuido: false,
      // temPendenciaDistribuicao: false,
      showEstruturaDistribuicao: false,
      // expandedRows: [],
      aguardeDialog: false,
      selectedSala: null,
      processo: {
        id: null,
        nome: "",
        datHoraInicioInscricao: "",
        datHoraFimInscricao: "",
        coeficienteMinimo: null,
        areas: [],
      },
      inscricoes: [],
      perfil: "",
      // localProva: null,
      localProva: {
        id: null,
        nome: "",
        fileAndaresSalas: null,
        andares: [],
        endereco: {
          logradouro: "",
          numero: "",
          complemento: "",
          bairro: "",
          cep: "",
          cidade: {
            nome: "",
            estado: {
              uf: "",
              nome: "",
            },
          },
        },
      },
      distribuicoes: [],
      distribuicaoConcluida: false,
      processoService: null,
    };
  },

  created() {
    this.localProvaService = new LocalProvaService();
    this.salaService = new SalaService();
    this.inscricaoService = new InscricaoService();
    this.processoService = new ProcessoService();
  },
  mounted() {
    this.showEditarDialog = false;
    this.showDetalheDialog = false;
    this.setProcessoAtivo();
  },
  watch: {
  	processoSelecionado() {
      this.processo = this.processoSelecionado;
      this.messagesDistribuicao = [];
      this.setProcessoAtivo();
  	},
  },
  computed: {
    processoSelecionado: {
      get() {
        return this.$store.state.processoSelecionado;
      },
    },
    isDistribuido: function() {
      // console.log("isDistribuido", this.processo);
      return this.processo && this.processo.estadoSelecao && this.processo.estadoSelecao.distribuido;
    },
    isLoading: function(){
      return this.aguardeDialog || this.carregandoLocalProva;
    },
    temPendenciaDistribuicao: function() {
      return this.pendenciasDistribuicao && this.pendenciasDistribuicao.length > 0;
    },
  },
  methods: {
    abrirNovoLocalProva() {
      this.showEditarDialog = true;
      this.localProvaSelecionado = this.criarLocalProva();
    },
    alterar() {
      this.messagesCadastroLocal = [];
    },
    cadastrar() {
      this.cadastroEscolaDialog = true;
    },
    criarLocalProva() {
      return {  id: null, nome: "",
                fileAndaresSalas: null,
                areasLocalProva: [],
                andares: [],
                endereco: { logradouro: "", numero: "", complemento: "",  bairro: "", cep: "",
                    cidade: { nome: "",
                    estado: { uf: "", nome: "" },
                },  },
              };
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },

    async getInscritosSalaExtra(id) {
      await this.inscricaoService.findBySelecaoEstagioInscricaoSalaExtra(id)
        .then((qt) => {
          this.qtCandidatos = qt.length;
        })
        .catch((erro) => {
          // console.log("erro: ", erro.data);
          this.messagesDistribuicao = this.getMessagesError(erro);
          this.aguardeDialog = false;
        });

      return this.qtCandidatos;
    },
    // getArea(sala) {
    //   return sala.inscricoesEstagioDto && sala.inscricoesEstagioDto.length > 0
    //               ? sala.inscricoesEstagioDto[0].nomeArea: "Sala não utilizada";
    // },

    getArea(sala){
      return sala.inscricoesEstagioDto && sala.inscricoesEstagioDto.length>0 ? sala.inscricoesEstagioDto[0].nomeArea : 'Sala não utilizada';
    },

    // collapsedLocalProva() {
    //   return this.localProva != null && this.localProva.id != null ? true : false;
    // },

    inscricoesEmAberto() {
      return this.processoSelecionado.abertoParaInscricao;
    },
    // inscricoesEmAberto(data_fim_inscricao) {
    //   const dataAtual = new Date();
    //   var fimInscricaoDate = new Date(data_fim_inscricao);
    //   return fimInscricaoDate.getTime() > dataAtual.getTime();
    // },

    // findIndexById(id) {
    //   let index = -1;
    //   for (let i = 0; i < this.inscricoes.length; i++) {
    //     if (this.inscricoes[i].id.selecaoEstagio.id === id) {
    //       index = i;
    //       break;
    //     }
    //   }
    //   return index;
    // },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.inscricoes.length; i++) {
        if (this.inscricoes[i].id.selecaoEstagio.id === id) {
          index = i;
          break;
        }
      }
      return index;
    },

    download(tituloArquivo) {
      this.aguardeDialog = true;

      this.inscricaoService.exportar(this.processo.id, tituloArquivo).then(()=>{
        this.aguardeDialog = false;
      }).catch(()=>{
        this.aguardeDialog = false;
      });
    },
		save() {
			this.messagesCadastroLocal=[];

      if(this.localProva.fileAndaresSalas==null){
        this.messagesCadastroLocal = [{severity: 'error', content: 'Arquivo de estrutura é obrigatório'}];
      }

      // console.log('cadastrarLocalProva...');
      const fd = new FormData();
      fd.append('selecaoEstagioId', this.processo.id);
      fd.append('nome', this.localProva.nome);
      fd.append('cep', this.localProva.endereco.cep);
      fd.append('logradouro', this.localProva.endereco.logradouro);
      fd.append('numero', this.localProva.endereco.numero);
      fd.append('complemento', this.localProva.endereco.complemento);
      fd.append('bairro', this.localProva.endereco.bairro);
      fd.append('cidade', this.localProva.endereco.cidade.nome);
      fd.append('uf', this.localProva.endereco.cidade.estado.uf);

      fd.append('andaresSalas', this.localProva.fileAndaresSalas);

      this.localProvaService.createOrUpdate(fd)
        .then(() => {
          this.setProcessoAtivo();
          this.hideDialog();
        })
        .catch(erro =>  {
          // console.error(erro);
          this.messagesCadastroLocal = this.getMessagesError(erro);
          this.aguardeDialog = false;
        })
    },

    async getQtCandidatos(id){

      await this.inscricaoService.getQtCandidatos(id)
        .then((qt) => { this.qtCandidatos = qt;
          // console.log(qt);
        })
        .catch(erro =>  {
          // console.log('erro: ', erro.data);
          this.messagesDistribuicao = this.getMessagesError(erro);
          this.aguardeDialog = false;
        })

      return this.qtCandidatos;
    },

    // async getQtCandidatos(id) {
    //   await this.inscricaoService
    //     .getQtCandidatos(id)
    //     .then((qt) => {
    //       this.qtCandidatos = qt;
    //     })
    //     .catch((erro) => {
    //       // console.log("erro: ", erro.data);
    //       this.messagesDistribuicao = this.getMessagesError(erro);
    //       this.aguardeDialog = false;
    //        this.hideDialog()
    //   });
    //   return this.qtCandidatos;
    // },

    collapsedLocalProva(){
      return this.localProva!=null&&this.localProva.id!=null ? true : false;
    },

    headerPanelLocalProva(){
      return this.localProva !=null && this.localProva.id != null ? 'Local da prova: ' + this.localProva.nome : 'Cadastre o local da prova';
    },

    formatarDataBR(dataUS) {
      return new Date(dataUS).toLocaleString();
    },


    // distribuirLocalProva(){
    //   this.aguardeDialog = true;
    //   this.messagesDistribuicao = [];
    //   http.get(`inscricao/distribuir-local-prova/${this.processo.id}`)
    //     .then(() => {
    //       this.setProcessoAtivo();
    //     })
    //     .catch(erro =>  {
    //       // console.log('erro: ', erro.data);
    //       this.messagesDistribuicao = this.getMessagesError(erro);
    //       this.aguardeDialog = false;
    //     })
    // },
    distribuirLocalProva() {
      this.aguardeDialog = true;
      this.messagesDistribuicao = [];
      http.get(`inscricao/distribuir-local-prova/${this.processo.id}`)
        .then(() => {
          this.setProcessoAtivo();
          this.aguardeDialog = false;
        })
        .catch((erro) => {
          console.log("erro: ", erro.data);
          this.messagesDistribuicao = this.getMessagesError(erro);
          this.aguardeDialog = false;
        });
    },

    onFileSelected(event){
      // console.log('onFileSelected file_andares_salas...')
      this.messages = [];
      this.localProva.fileAndaresSalas = event.target.files[0]
      var fileUpload = document.getElementById("file_andares_salas");
      // console.log('fileUpload.value ...', fileUpload.value);

      if(!fileUpload.value.endsWith('.xlsx')) {
        this.fileAndaresSalas = null;
        fileUpload.value='';
        this.messages = [{severity: 'error', content: 'Somente arquivos do tipo *.xlsx são permitidos'}];
      }
    },

    downloadParaAssinar(tituloArquivo) {
      this.aguardeDialog = true;

      this.inscricaoService.exportarParaAssinar(
        this.processo.id,
        tituloArquivo
      ).then(()=>{
      this.aguardeDialog = false;
      }).catch(()=>{
         this.aguardeDialog = false;
      });

    },

    downloadCartoesUfam() {
      this.aguardeDialog = true;

      this.processoService.exportarCartoesUfam(this.processo.id, "cartoes_ufam")
          .then(()=>{
            this.aguardeDialog = false;
          }).catch(()=>{
            this.aguardeDialog = false;
          });

    },

    setProcessoAtivo() {
        this.processoService.getProcesso(this.processoSelecionado.id)
          .then((resposta) => {
            this.processo = resposta;
            this.processo.datHoraFimInscricao = this.$formatarDataHoraBR(this.processo.datHoraFimInscricao);
            this.processo.datHoraInicioInscricao = this.$formatarDataHoraBR(this.processo.datHoraInicioInscricao);
            this.temProcessos = true;
            // this.podeDistribuirLocalProva = this.processo.estadoSelecao.podeDistribuirLocalProva;
            // this.isDistribuido = this.processo && this.processo.estadoSelecao && this.processo.estadoSelecao.distribuido;
            this.getInscritosSalaExtra(this.processo.id);
            this.setLocalProva(this.processo.id);
        }).catch(() => {
          // this.messages = this.getMessagesError(erro);
          this.aguardeDialog = false;
        });
    },
    setLocalProva(processoId) {
      this.$store.state.dlgLoading = true;
      this.pendenciasDistribuicao = [];
      this.showEstruturaDistribuicao = false;
      this.carregandoLocalProva = true;
      this.localProvaService.getListaLocalProvaBySelecao(processoId)
        .then((resposta) => {
            this.listaLocalProva = resposta;
            // this.getAreasPendentesDeLocalDeProva();
            this.getPendeciasDistribuicao(processoId);
            this.$store.state.dlgLoading = false;
        }).catch(() => {
          // this.messages = this.getMessagesError(erro);
          this.carregandoLocalProva = false;
          this.$store.state.dlgLoading = false;
        });
    },
    getPendeciasDistribuicao(processoId) {
      this.inscricaoService.getPendenciasDistribuicao(processoId)
      .then((resposta) => {
          this.pendenciasDistribuicao    = resposta;
          // this.temPendenciaDistribuicao  = this.pendenciasDistribuicao && this.pendenciasDistribuicao.length > 0;
          this.showEstruturaDistribuicao = this.isDistribuido && !this.temPendenciaDistribuicao;
          this.carregandoLocalProva     = false;
        }).catch(() => {
          this.carregandoLocalProva = false;
        });
    },
    novoLocalProva() {
      let localProva =  {
                        id: null,
                        nome: "",
                        fileAndaresSalas: null,
                        andares: [],
                        areasLocalProva: [],
                        endereco: {
                          logradouro: "",
                          numero: "",
                          complemento: "",
                          bairro: "",
                          cep: "",
                          cidade: {
                            nome: "",
                            estado: {
                              uf: "",
                              nome: "",
                            },
                          },
                        },
                      };
      return localProva;
    },
    editarLocalProva(registro) {
      this.localProvaSelecionado = registro;
      this.showEditarDialog = true;
      this.flagEditarLocal  = true;
    },
    detalharEscola(registro) {
      this.localProvaSelecionado = registro;
      this.showDetalheDialog = true;
    },
    excluirLocalProva(registro) {
      this.localProvaSelecionado = registro;
      this.showConfirmacaoDialog = true;
    },
    confirmarExclusao() {
      // console.log("Confirmando exclusão");
      this.aguardeDialog = true;
      this.localProvaService.removerLocalProva(this.localProvaSelecionado.id)
          .then(() => {
              this.setLocalProva(this.processoSelecionado.id);
              this.aguardeDialog = false;
            }).catch(() => {
              // this.messages = this.getMessagesError(erro);
              this.aguardeDialog = false;
            });
    },
    podeDistribuirLocalProva() {
      // console.log("tem pendencia", this.temPendenciaDistribuicao);
      return this.processo && this.processo.estadoSelecao && this.processo.estadoSelecao.podeDistribuirLocalProva && !this.temPendenciaDistribuicao;
    },
  },
};
</script>

<style scoped>
.aguarde {
  width: 130px;
  height: 130px;
  text-align: center;
}
</style>
